import { Layout } from "antd";
import React from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import "./App.css";
import RegisterConfirm from "./components/RegisterForm/RegisterConfirm";
import RegisterForm from "./components/RegisterForm/RegisterForm";
import LoginForm from "./components/LoginForm/LoginForm";
import HeaderContent from "./components/UI/HeaderContent/HeaderContent";
import PrivateRoute from "./components/UI/PrivateRoute/PrivateRoute";
import PublicRoute from "./components/UI/PublicRoute/PublicRoute";
import TermsAndConditions from "./components/RegisterForm/TermsAndConditions";
import ForgotPasswordForm from "./components/ForgotPasswordForm/ForgotPasswordForm";
import ForgotPasswordConfirm from "./components/ForgotPasswordForm/ForgotPasswordConfirm";
import ChangePasswordForm from "./components/ChangePasswordForm/ChangePasswordForm";
import ChangePasswordConfirm from "./components/ChangePasswordForm/ChangePasswordConfirm";
import RescoConfig from "./utils/rescoConfig";
import VisitList from "./components/VisitList/VisitList";
import AddVisit from "./components/AddVisit/AddVisit";
import LandingPage from "./components/UI/LandingPage/LandingPage";

const { Header, Content, Footer } = Layout;

function App() {
  return (
    <BrowserRouter basename={RescoConfig.RouterBaseName}>
      <Layout>
        <Header className="app-header">
          <HeaderContent></HeaderContent>
        </Header>
        <Content className="App">
          <Switch>
            <PublicRoute
              component={RegisterForm}
              path="/register"
              protected={true}
              exact={true}
            ></PublicRoute>
            <PublicRoute
              component={TermsAndConditions}
              path="/termsandconditions"
              protected={false}
              exact={true}
            ></PublicRoute>
            <PublicRoute
              component={RegisterConfirm}
              path="/registerconfirm"
              protected={true}
              exact={true}
            ></PublicRoute>
            <PublicRoute
              component={LoginForm}
              path="/login"
              protected={true}
              exact={true}
            ></PublicRoute>
            <PublicRoute
              component={ForgotPasswordForm}
              path="/ForgotPassword"
              protected={true}
              exact={true}
            ></PublicRoute>
            <PublicRoute
              component={ForgotPasswordConfirm}
              path="/ForgotPasswordConfirm"
              protected={true}
              exact={true}
            ></PublicRoute>
            <PublicRoute
              component={ChangePasswordForm}
              path="/ChangePassword"
              protected={true}
              exact={true}
            ></PublicRoute>
            <PublicRoute
              component={ChangePasswordConfirm}
              path="/ChangePasswordConfirm"
              protected={true}
              exact={true}
            ></PublicRoute>
            <PrivateRoute
              component={ChangePasswordConfirm}
              path="/register"
              exact={true}
            ></PrivateRoute>
            <PrivateRoute
              component={VisitList}
              path="/visit"
              exact={true}
            ></PrivateRoute>
            <PublicRoute
              component={AddVisit}
              path="/addvisit"
              protected={false}
              exact={true}
            ></PublicRoute>
            <PublicRoute
              component={LandingPage}
              path="/"
              protected={false}
              exact={false}
            ></PublicRoute>
          </Switch>
        </Content>

        <Footer>Resco Visits</Footer>
      </Layout>
    </BrowserRouter>
  );
}

App.displayName = "App";

export default App;
